module.exports = __webpack_public_path__ + "img/png.5e414af4.svg";